module.exports = __webpack_public_path__ + "static/img/video_icon4.bf56544.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/broadcast/video_icon4.png
// module id = kOVO
// module chunks = 0